export const DCL_FORM_ID = 1
export const IDR_FORM_ID = 0
export const RPR_FORM_ID = 11
export const TLF_FORM_ID = '62c71fe2f9b48441770bf320';
